import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyBanner } from "@/components/StickyBanner";
import { SEO } from "@/components/SEO";
import { SpanishHero } from "@/components/SpanishHero";
import { SpanishWhyUs } from "@/components/SpanishWhyUs";
import { SpanishServices } from "@/components/SpanishServices";
import { SpanishTestimonials } from "@/components/SpanishTestimonials";
import { SpanishFAQ } from "@/components/SpanishFAQ";
import { SpanishFinalCTA } from "@/components/SpanishFinalCTA";
import { LocationContext } from "@/lib/locations";

import { Guarantee } from "@/components/Guarantee";
import { PricingCalculator } from "@/components/PricingCalculator";
import { FrequencyDiscounts } from "@/components/FrequencyDiscounts";

const WEST_LA_CITIES = ["West Los Ángeles", "Santa Mónica", "Venice", "Brentwood", "Culver City", "Mar Vista", "Palms", "Westwood"];

const WestLASpanishPage = () => {
  return (
    <LocationContext.Provider value={{ slug: "west-la", name: "Oeste de Los Ángeles", type: "city", regionSlug: "los-angeles" }}>
      <SEO
        title="Limpieza del Hogar en el Oeste de Los Ángeles — Uplevel Cleaning"
        description="Servicio profesional de limpieza del hogar en West LA, Santa Mónica, Venice, Brentwood, Culver City y más. Precios planos, reserva en 60 segundos, garantía del 200%."
        keywords="limpieza del hogar west la, servicio de limpieza santa monica, limpieza profunda oeste de los angeles, empleada doméstica west la, limpieza venice, limpieza brentwood, limpieza culver city, limpieza westwood"
        url="https://uplevelcleaning.com/es/west-la"
        alternateUrl="https://uplevelcleaning.com/locations/la/la-westside"
        alternateLang="en-US"
        locationName="Oeste de Los Ángeles"
        regionSlug="los-angeles"
        lang="es"
        includeLocalBusiness={true}
        includeFAQ={true}
        breadcrumbs={[
          { name: "Inicio", url: "/" },
          { name: "En Español", url: "/es" },
          { name: "Los Ángeles", url: "/es/los-angeles" },
          { name: "Oeste de LA", url: "/es/west-la" }
        ]}
        reviews={[
          { author: "Valentina M.", rating: 5, reviewBody: "Vivo en Santa Mónica y Uplevel Cleaning es el mejor servicio que he encontrado. ¡Puntuales, profesionales y detallistas!", datePublished: "2026-03-18" },
          { author: "Andrés P.", rating: 5, reviewBody: "Mi apartamento en Venice quedó impecable. Muy fácil reservar en línea y el precio fue exactamente lo que me dijeron.", datePublished: "2026-02-22" },
          { author: "Luciana F.", rating: 5, reviewBody: "Servicio de primera en Culver City. El equipo fue amable, rápido y dejó todo perfecto. Los recomiendo al 100%.", datePublished: "2026-01-30" }
        ]}
      />
      <div className="flex min-h-screen flex-col" lang="es">
        <StickyBanner />
        <Navbar />
        <main className="flex-1">
          <SpanishHero cityName="el Oeste de Los Ángeles" regionSlug="los-angeles" />
          <SpanishWhyUs cityName="el Oeste de Los Ángeles" />

          {/* Cities served */}
          <section className="py-16 bg-muted/30">
            <div className="container">
              <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">Ciudades que Servimos en el Oeste de LA</h2>
              <div className="flex flex-wrap justify-center gap-4">
                {WEST_LA_CITIES.map((city) => (
                  <span
                    key={city}
                    className="flex items-center gap-2 px-5 py-3 rounded-full border bg-background font-semibold text-sm shadow-sm"
                  >
                    📍 {city}
                  </span>
                ))}
              </div>
            </div>
          </section>

          <SpanishServices />

          <FrequencyDiscounts />
          <PricingCalculator />
          <SpanishTestimonials region="la" />
          <Guarantee />
          <SpanishFAQ cityName="el Oeste de Los Ángeles" />
          <SpanishFinalCTA cityName="el Oeste de Los Ángeles" />
        </main>
        <Footer />
      </div>
    </LocationContext.Provider>
  );
};

export default WestLASpanishPage;
